module.exports = __webpack_public_path__ + "site/img/servicecn.cc404a4d.jpeg";